module.exports = ".font-clr {\n    font-size: 60px !important;\n    color: #4285f4;\n}"